// src/redux/companyProspect/companyProspectSelectors.js

// ✅ Create Company Prospect
export const selectCreateCompanyProspectData = (state) =>
  state?.companyProspect?.createCompanyProspect?.data;
export const selectCreateCompanyProspectLoading = (state) =>
  state?.companyProspect?.createCompanyProspect?.loading;
export const selectCreateCompanyProspectError = (state) =>
  state?.companyProspect?.createCompanyProspect?.error;

// ✅ Company Prospect Generated URL
export const selectCompanyProspectGeneratedUrlData = (state) =>
  state?.companyProspect?.getCompanyProspectGeneratedUrl?.data;
export const selectCompanyProspectGeneratedUrlLoading = (state) =>
  state?.companyProspect?.getCompanyProspectGeneratedUrl?.loading;
export const selectCompanyProspectGeneratedUrlError = (state) =>
  state?.companyProspect?.getCompanyProspectGeneratedUrl?.error;

// ✅ Generate Company Prospect URL
export const selectGenerateCompanyProspectUrlData = (state) =>
  state?.companyProspect?.generateCompanyProspectUrl?.data;
export const selectGenerateCompanyProspectUrlLoading = (state) =>
  state?.companyProspect?.generateCompanyProspectUrl?.loading;
export const selectGenerateCompanyProspectUrlError = (state) =>
  state?.companyProspect?.generateCompanyProspectUrl?.error;

// ✅ Company Prospect Listing
export const selectCompanyProspectList = (state) =>
  state?.companyProspect?.getCompanyProspectListing?.data || [];
export const selectCompanyProspectListLoading = (state) =>
  state?.companyProspect?.getCompanyProspectListing?.loading;
export const selectCompanyProspectListError = (state) =>
  state?.companyProspect?.getCompanyProspectListing?.error;
export const selectCompanyProspectListTotal = (state) =>
  state?.companyProspect?.getCompanyProspectListing?.total || 0;

// ✅ Company Prospect Detail
export const selectCompanyProspectDetail = (state) =>
  state?.companyProspect?.getCompanyProspectDetail?.data;
export const selectCompanyProspectDetailLoading = (state) =>
  state?.companyProspect?.getCompanyProspectDetail?.loading;
export const selectCompanyProspectDetailError = (state) =>
  state?.companyProspect?.getCompanyProspectDetail?.error;

// ✅ Company Employees
export const selectCompanyEmployeesList = (state) =>
  state?.companyProspect?.getCompanyEmployees?.data || [];
export const selectCompanyEmployeesLoading = (state) =>
  state?.companyProspect?.getCompanyEmployees?.loading;
export const selectCompanyEmployeesError = (state) =>
  state?.companyProspect?.getCompanyEmployees?.error;
export const selectCompanyEmployeesTotal = (state) =>
  state?.companyProspect?.getCompanyEmployees?.total || 0;

// ✅ Company Employee Detail
export const selectCompanyEmployeeDetail = (state) =>
  state?.companyProspect?.getCompanyEmployeeDetail?.data;
export const selectCompanyEmployeeDetailLoading = (state) =>
  state?.companyProspect?.getCompanyEmployeeDetail?.loading;
export const selectCompanyEmployeeDetailError = (state) =>
  state?.companyProspect?.getCompanyEmployeeDetail?.error;

// ✅ Convert Company Prospect
export const selectConvertCompanyProspectData = (state) =>
  state?.companyProspect?.convertCompanyProspect?.data;
export const selectConvertCompanyProspectLoading = (state) =>
  state?.companyProspect?.convertCompanyProspect?.loading;
export const selectConvertCompanyProspectError = (state) =>
  state?.companyProspect?.convertCompanyProspect?.error;

// ✅ Combined
export const selectCompanyProspectState = (state) => state?.companyProspect;